"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSection = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var DisabledBubbleMessage_1 = tslib_1.__importDefault(require("../DisabledBubbleMessage"));
var translations_1 = require("../../utils/translations");
var ConfigSection = /** @class */ (function (_super) {
    tslib_1.__extends(ConfigSection, _super);
    function ConfigSection(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.toggleCollapsed = _this.toggleCollapsed.bind(_this);
        _this.toggleValue = _this.toggleValue.bind(_this);
        var collapsed = (_c = (_b = (_a = props.propertiesMeta) === null || _a === void 0 ? void 0 : _a[props.id]) === null || _b === void 0 ? void 0 : _b.collapsed) !== null && _c !== void 0 ? _c : true;
        _this.state = {
            collapsed: collapsed,
        };
        return _this;
    }
    ConfigSection.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _a, _b, _c;
        // TODO: should the indexer be "nextProps.id"? Leaving as-is for now to be safe.
        var collapsed = (_c = (_b = (_a = nextProps.propertiesMeta) === null || _a === void 0 ? void 0 : _a[this.props.id]) === null || _b === void 0 ? void 0 : _b.collapsed) !== null && _c !== void 0 ? _c : true;
        this.setState({ collapsed: collapsed });
    };
    ConfigSection.prototype.render = function () {
        var collapsed = this.state.collapsed;
        var _a = this.props, title = _a.title, intl = _a.intl, subtitle = _a.subtitle, className = _a.className;
        var configSectionClassName = "adi-bucket-configuration " + className;
        return (react_1.default.createElement("div", { className: this.getSectionClassNames() },
            react_1.default.createElement("div", { className: this.getHeaderClassNames(), onClick: this.toggleCollapsed }, translations_1.getTranslation(title, intl) + (subtitle ? " (" + translations_1.getTranslation(subtitle, intl) + ")" : "")),
            this.renderToggleSwitch(),
            react_1.default.createElement("div", { className: configSectionClassName }, !collapsed && this.props.children)));
    };
    ConfigSection.prototype.renderToggleSwitch = function () {
        if (this.props.canBeToggled) {
            var _a = this.props, toggledOn = _a.toggledOn, toggleDisabled = _a.toggleDisabled, showDisabledMessage = _a.showDisabledMessage;
            return (react_1.default.createElement(DisabledBubbleMessage_1.default, { className: "adi-bucket-item-toggle", showDisabledMessage: showDisabledMessage },
                react_1.default.createElement("label", { className: this.getToggleLabelClassNames() },
                    react_1.default.createElement("input", { type: "checkbox", checked: toggledOn, disabled: toggleDisabled, onChange: this.toggleValue, className: "s-checkbox-toggle " + (toggleDisabled ? "s-disabled" : "s-enabled") }),
                    react_1.default.createElement("span", { className: "input-label-text" }))));
        }
        return null;
    };
    ConfigSection.prototype.getHeaderClassNames = function () {
        var collapsed = this.state.collapsed;
        return classnames_1.default("adi-bucket-item-header", "adi-configuration-section-header", "s-configuration-panel-item-header", {
            expanded: !collapsed,
            "adi-bucket-item-header-has-toggle": this.props.canBeToggled,
            collapsed: collapsed,
        });
    };
    ConfigSection.prototype.getToggleLabelClassNames = function () {
        return classnames_1.default("input-checkbox-toggle", "s-checkbox-toggle-label");
    };
    ConfigSection.prototype.getSectionClassNames = function () {
        return classnames_1.default("adi-bucket-item", "s-config-section-" + this.props.id);
    };
    ConfigSection.prototype.toggleCollapsed = function () {
        var collapsed = this.state.collapsed;
        var propertiesMeta = {};
        propertiesMeta[this.props.id] = {
            collapsed: !collapsed,
        };
        this.setState({ collapsed: !collapsed });
        this.props.pushData({ propertiesMeta: propertiesMeta });
    };
    ConfigSection.prototype.toggleValue = function (event) {
        var _a = this.props, valuePath = _a.valuePath, properties = _a.properties, pushData = _a.pushData;
        if (valuePath && properties && pushData) {
            var clonedProperties = cloneDeep_1.default(properties);
            set_1.default(clonedProperties, "controls." + valuePath, event.target.checked);
            pushData({ properties: clonedProperties });
        }
    };
    ConfigSection.defaultProps = {
        collapsed: true,
        canBeToggled: false,
        toggleDisabled: false,
        toggledOn: true,
        disabled: false,
        pushData: noop_1.default,
        showDisabledMessage: false,
        className: "",
        properties: {},
    };
    return ConfigSection;
}(react_1.default.Component));
exports.ConfigSection = ConfigSection;
exports.default = react_intl_1.injectIntl(ConfigSection);
//# sourceMappingURL=ConfigSection.js.map